import { WarehouseEntityType } from '@/__generated__/graphql';
import {
  HandoffAssetDataWarehouseType,
  HandoffAssetDbtType,
} from '@/hooks/telemetry/handoffs';
import { HandoffDWHObjectTypes } from '@/hooks/visual-editor/types';
import { NavigationResourceType } from '@/panel/ResourcesFilter/selectedResource';

export const toHandoffAssetDbtType = (
  resourceType: Omit<NavigationResourceType, 'test'>,
): HandoffAssetDbtType => {
  return `dbt_${resourceType}` as HandoffAssetDbtType;
};

export const toHandoffAssetDataWarehouseType = (
  dataWarehouseType: HandoffDWHObjectTypes,
): HandoffAssetDataWarehouseType => {
  switch (dataWarehouseType) {
    case WarehouseEntityType.Table:
      return 'data_warehouse_table';
    case WarehouseEntityType.View:
      return 'data_warehouse_view';
    default:
      return 'unknown';
  }
};
